// src/components/Walkthrough.jsx
import React from "react";
import { Container, Card, Row, Col, Badge, Button, Table } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function Walkthrough() {
  const updates = [
    {
      date: "19 Septembrie 2026",
      badgeColor: "primary",
      title: "🚀 Modul Producție Independent și Management Avansat Manoperă",
      category: "Producție & Arhitectură",
      description:
        "S-a implementat arhitectura complet izolată pentru modulul de Producție (MES), decuplându-l funcțional și la nivel de UI/meniuri față de Service Auto. S-a introdus trasabilitatea materialelor și sincronizarea manoperei.",
      items: [
        "<strong>Decuplarea Meniurilor (TopBar):</strong> Meniul aplicației folosește variabila `appVariant` pentru a afișa strict rutele necesare companiei. Profilurile de Producție nu mai văd module de Service Auto și viceversa.",
        "<strong>Coduri Manoperă Producție (Izolare Totală):</strong> S-a creat o nouă tabelă <code>bxmanoperaprodlk</code> și rută dedicată <code>/coduri-manopera-prod</code> pentru operațiunile de producție (strunjire, debitare), separate fizic de codurile din service auto.",
        "<strong>Integrare Gestiune și Manoperă:</strong> Comenzile de producție folosesc componenta avansată <code>&lt;LaborEmployees&gt;</code> pentru repartizarea tarifelor (Skill 1 și 2) direct din interfața comenzii.",
        "<strong>Trasabilitate (Istoric Consum):</strong> Prin <code>bxcomandaprod_istoric_consum</code> se urmăresc perfect scăderile parțiale de materiale din gestiune, direct legate de comandă prin ID-ul unic în <code>Stocdoc</code>.",
      ],
      tables: [
        {
          title: "📂 Arhitectura Tabelelor: Producție vs Service Auto (Separare și Zone Comune)",
          headers: ["Modul / Scop", "Tabel", "Descriere & Rol"],
          rows: [
            ["Producție (Izolat)", "bxcomandaprod", "Antetul comenzilor de producție (nr. document, dată, produs finit)."],
            ["Producție (Izolat)", "bxcomandaprod_linii", "Materialele necesare (rețeta aplicată pe comandă)."],
            ["Producție (Izolat)", "bxcomandaprod_istoric_consum", "Scăderile/Transferurile parțiale de materiale de pe comandă."],
            ["Producție (Izolat)", "bxcomandaprod_manopera", "Liniile de manoperă adăugate pe o comandă de producție."],
            ["Producție (Izolat)", "bxmanoperaprodlk", "Nomenclatorul codurilor de manoperă dedicat producției (Strunjire, Debitare)."],
            ["Producție (Izolat)", "bxreteta / bxretetalinii", "Definirea rețetelor standard (BOM)."],
            ["Service Auto (Izolat)", "bxcomanda", "Antetul devizelor / comenzilor auto."],
            ["Service Auto (Izolat)", "bxcomtr", "Liniile cu piesele auto și materialele adăugate pe deviz."],
            ["Service Auto (Izolat)", "bxmanopera", "Liniile de manoperă adăugate pe deviz."],
            ["Service Auto (Izolat)", "bxmanoperalk", "Nomenclatorul codurilor de manoperă auto (Demontare, Vopsitorie)."],
            ["GLOBAL (Comun)", "bxpart", "Nomenclatorul general (Materii Prime, Piese Auto, Produse Finite)."],
            ["GLOBAL (Comun)", "contacte", "Clienții (pe deviz/comandă) și Angajații (mecanici, strungari)."],
            ["GLOBAL (Comun)", "bxgestiune", "Gestiunile pentru scăderea și intrarea stocurilor fizice."],
            ["GLOBAL (Comun)", "bxfirma", "Regulile generale și valorile Tarif Skill 1 & Tarif Skill 2 aplicabile peste tot."]
          ]
        }
      ]
    },
    {
      date: "17 Septembrie 2026",
      badgeColor: "info",
      title: "🛠️ Arhitectura rec_type (Tipuri de Documente)",
      category: "Documentație Tehnică",
      description:
        "Sistemul ERP folosește un câmp standardizat (rec_type) pentru a clasifica tipurile de operațiuni și documente logistice din baza de date, legând documentul principal de liniile de stoc și de contabilitate.",
      tables: [
        {
          title: "🟢 Fluxuri Logistice Curente (Standard)",
          headers: ["rec_type", "Operațiune", "Tabel Master", "Detalii & Rol"],
          rows: [
            [
              "0",
              "Recepție Marfă (Intrare)",
              "Intrare",
              "Achiziții externe de la furnizori (facturi). Generează stoc nou (Stocin)."
            ],
            [
              "1",
              "NIR (Notă Intrare Recepție)",
              "Stocdoc",
              "Recepții pe aviz intern sau de la furnizori care necesită NIR separat."
            ],
            [
              "2",
              "Proces Verbal",
              "Stocdoc",
              "Ajustări de stoc (plus/minus de inventar, procese verbale de custodie)."
            ],
            [
              "3",
              "Bon de Consum",
              "Stocdoc",
              "Include și consumul materialelor din Deviz. Scade stocul și trece piesele pe cheltuială (6xx = 3xx)."
            ],
            [
              "4",
              "Bon de Transfer",
              "Stocdoc",
              "Mutarea mărfurilor între două gestiuni interne. Generează NC de transfer (ex: 371 = 371)."
            ],
            [
              "5",
              "Ieșire / Vânzare",
              "Iesire",
              "Facturi de vânzare către client sau avize de expediție."
            ],
            [
              "6",
              "Bon de Producție",
              "Stocdoc",
              "Operațiuni de fabricație sau asamblare (piese consumate se transformă în produs finit)."
            ]
          ]
        },
        {
          title: "🔴 Fluxuri Istorice / Depășite (Dezafectate)",
          headers: ["rec_type", "Operațiune", "Stare Actuală"],
          rows: [
            [
              "11",
              "Manoperă (Deviz)",
              "Dezafectat. Nu afecta stocul, se scria direct pe deviz."
            ],
            [
              "12",
              "Consum Direct (Deviz)",
              "Înlocuit cu rec_type 3. Fostul sistem de scădere directă fără bon fizic; absorbit complet de Bon Consum standard."
            ]
          ]
        }
      ]
    },
    {
      date: "14 Septembrie 2026",
      badgeColor: "warning",
      title: "🔒 Tab Nou de Securitate și Reguli de Acces",
      category: "Setări Firmă",
      description:
        "S-a adăugat un nou tab de 'Securitate' în configurarea firmei, centralizând politicile de acces, parole și restricții.",
      items: [
        "<strong>Whitelist IP-uri:</strong> Accesul la firmă poate fi acum restricționat doar pentru o listă specificată de IP-uri.",
        "<strong>Securitate Cont (Lockout):</strong> Conturile sunt blocate automat după un anumit număr de încercări eșuate de autentificare.",
        "<strong>Politici de Parolă și Sesiune:</strong> S-au introdus opțiuni pentru complexitatea obligatorie a parolei, expirarea ei la X zile și deconectarea automată la inactivitate.",
        "<strong>Max Luni Deschise:</strong> Restricționarea numărului maxim de luni fiscale deschise simultan (nu mai mult de 5)."
      ],
    },
    {
      date: "08 Septembrie 2026",
      badgeColor: "success",
      title: "🔄 Tratament TVA la Import Facturi & Formatare Date NC",
      category: "Import Facturi & NC",
      description:
        "Tratamentul contabil automat al TVA-ului la importul facturilor de intrare în funcție de regimul de TVA la încasare, plus formatarea unitară a datelor în modulul NC.",
      tables: [
        {
          title: "📥 Facturi Furnizori (Intrări / Achiziții)",
          headers: [
            "Situație firmă beneficiară (Tu)",
            "Situație Furnizor",
            "Cum tratează ERP-ul la import?"
          ],
          rows: [
            [
              "NU ești cu TVA la încasare",
              "NU este cu TVA la încasare",
              "TVA deductibil direct (4426 = 401). Deductibilitatea se exercită în luna primirii facturii."
            ],
            [
              "NU ești cu TVA la încasare",
              "ESTE cu TVA la încasare",
              "TVA neexigibil (4428 = 401). Devenirea exigibilă (trecerea în 4426) se va face doar în momentul în care plătești acea factură (prin extras de cont/registru de casă)."
            ],
            [
              "ESTE cu TVA la încasare",
              "(Oricare variantă)",
              "TVA neexigibil (4428 = 401). Indiferent de regimul furnizorului, deoarece firma ta aplică acest sistem, TVA-ul devine deductibil doar la plată."
            ]
          ]
        },
        {
          title: "📤 Facturi Clienți (Ieșiri / Vânzări)",
          headers: [
            "Situație firma ta (Furnizor)",
            "Situație Client (Beneficiar)",
            "Cum tratează ERP-ul la import / generare?"
          ],
          rows: [
            [
              "NU ești cu TVA la încasare",
              "NU este cu TVA la încasare",
              "TVA colectat direct (4427 = 4111). Colectarea TVA-ului se înregistrează în luna emiterii facturii."
            ],
            [
              "NU ești cu TVA la încasare",
              "ESTE cu TVA la încasare",
              "TVA colectat direct (4427 = 4111). Deoarece firma ta nu este cu TVA la încasare, TVA-ul este colectat direct la data emiterii (regimul clientului nu influențează TVA-ul colectat)."
            ],
            [
              "ESTE cu TVA la încasare",
              "(Oricare variantă)",
              "TVA neexigibil (4428 = 4111). Deoarece firma ta aplică TVA la încasare, TVA-ul devine colectat (trece în 4427) doar la încasarea facturii (prin extras/casă)."
            ]
          ]
        }
      ],
      items: [
        "<strong>Format Unitar Dată zz/mm/yyyy în NC:</strong> Toate datele și selectoarele din modulul Notă Contabilă folosesc formatul unitar <code>zz/mm/yyyy</code> independent de setările regionale ale browser-ului.",
        "<strong>Corecție Salvare Editare NC:</strong> S-a rezolvat eroarea de salvare (flush înainte de insert) la editarea notelor contabile existente."
      ]
    },
    {
      date: "05 Septembrie 2026",
      badgeColor: "success",
      title:
        "🏦 Raport Zilnic pe Cont Casa / Bancă (Sold început zi, înregistrări zi, sold sfârșit zi)",
      category: "Casa / Banca & Rapoarte",
      description:
        "S-a implementat noul raport zilnic pe contul de trezorerie (ex: 5121 Banca ING, 5311 Casa etc.) cu calcularea soldului de început de zi, a tranzacțiilor din zi și a soldului de sfârșit de zi.",
      items: [
        "<strong>Calculare Sold Început și Sfârșit Zi:</strong> Sistemul calculează soldul de deschidere pentru fiecare zi cu activitate, însumează încasările (debit) și plățile (credit) din zi și afișează soldul de închidere al zilei.",
        "<strong>Grupare Cronologică pe Zile:</strong> Raportul este generabil pe orice interval de date ales și grupează curat tranzacțiile pe zile, afișând partenerul, nr. doc, tipul și explicația.",
        "<strong>Acces Rapid din Meniu & Tipărire:</strong> Meniul <em>Casa/Banca</em> conține noul link <code>Raport Zilnic Casa/Bancă</code> (/rapoarte/casa-zilnic), dotat cu carduri sintetice de solduri și opțiune de tipărire.",
      ],
    },
    {
      date: "05 Septembrie 2026",
      badgeColor: "primary",
      title: "📝 Despărțire Note Simple / Lista Note Contabile & Editare Note",
      category: "Contabilitate & Note Contabile",
      description:
        "S-a realizat separarea meniului Note Contabile în 'Note Simple' și 'Lista Note Contabile', s-a adăugat funcționalitatea de editare a notelor simple și s-a implementat restricția de editare pentru perioade închise.",
      items: [
        "<strong>Despărțire Meniuri (Note Simple vs. Lista Note Contabile):</strong> Meniul Contabilitate / Înregistrări a fost organizat în două căi distincte: <em>Note simple</em> (pentru introducerea și editarea notelor manuale, având butonul '+ Notă Nouă') și <em>Lista note contabile</em> (registrul jurnal cu toate notele, vizualizare doar).",
        "<strong>Editare Note Contabile Simple:</strong> S-a adăugat modulul de editare (ruta <code>/nc/edit/:rec_type/:doc_id</code>) permițând modificarea antetului și a liniilor de articole pentru notele manuale salvate.",
        "<strong>Restricție Perioadă Închisă (bxlast_date):</strong> Sistemul verifică data notei (<code>data_nc</code>) în raport cu data ultimei luni închise din firmă. Dacă perioada este închisă, editarea este blocată în interfață și orice cerere pe backend <code>PUT /nc/{rec_type}/{doc_id}</code> este respinsă cu eroare explicativă.",
      ],
    },
    {
      date: "10 Iulie 2026",
      badgeColor: "primary",
      title:
        "🌐 Integrare Completă OAuth 2.0 & Reîmprospătare Automată ANAF SPV",
      category: "eFactura, OAuth2 & SPV",
      description:
        "S-a integrat fluxul complet de autorizare OAuth 2.0 cu serverele ANAF, permițând obținerea facilă a token-ului direct din interfață și menținerea lui validă în mod automat.",
      items: [
        "<strong>Flux de Autorizare Direct (OAuth 2.0):</strong> Utilizatorul poate obține tokenul de acces direct din modulul eFactura printr-un singur click pe butonul '🌐 Obține Token Automat'. Aplicația realizează redirectarea securizată către ANAF și preia automat codul înapoi în aplicație, eliminând necesitatea copy-paste-ului manual.",
        "<strong>Reîmprospătare Automată cu Refresh Token:</strong> Sistemul verifică valabilitatea token-ului la fiecare cerere eFactura (trimitere, stare). Dacă acesta expiră în mai puțin de 5 zile, backend-ul FastAPI apelează automat serverul de tokens ANAF utilizând <code>refresh_token</code>, actualizând credențialele în fundal, fără a fi nevoie de token-ul USB la refresh.",
        "<strong>Alerte Inteligente pe Dashboard:</strong> La deschiderea paginii eFactura, aplicația verifică starea token-ului. Dacă acesta lipsește, este expirat sau aproape de expirare, se afișează o alertă direct pe ecran, însoțită de un buton de acțiune rapidă.",
        "<strong>Cerință Stick USB:</strong> S-a adăugat o notificare explicită în interfață pentru a reaminti utilizatorului să aibă stick-ul USB (semnătura digitală) conectat în calculator în timpul obținerii unui token nou.",
      ],
    },
    {
      date: "03 Iulie 2026",
      badgeColor: "success",
      title:
        "🌍 Tranzacții Externe (Valută), Taxare Inversă & Suport Multi-Tenant",
      category: "Financiar, Valută & Multi-Tenant",
      description:
        "S-au implementat fluxuri complete pentru facturi în valută (intrări și ieșiri), taxare inversă, preluare automată curs BNR și s-au migrat bazele de date pentru Rețete.",
      items: [
        "<strong>Taxare Inversă & Contabilitate Automatizată (21.TI, 11.TI, 0.TI):</strong> La introducerea cotelor speciale cu marcaj de taxare inversă (.TI), notele contabile de achiziție generează automat înregistrări <code>4426</code> = <code>4427</code>, evitând creditarea eronată a contului de furnizor 40102 pentru suma TVA.",
        "<strong>Cursuri Duble & Diferențe de Curs:</strong> Pentru achizițiile externe, stocurile se evaluează la cursul BNR de la data recepției (bxinput_date), în timp ce furnizorul se creditează la cursul facturii de la data documentului (bxdoc_date). Diferențele valorice dintre cele două cursuri se înregistrează automat în conturile de venituri/cheltuieli din diferențe de curs (765 / 665).",
        "<strong>Ieșiri în Valută (Vânzări Externe):</strong> S-a adăugat suport pentru valute pe facturile de ieșire. La selectarea unui client extern, interfața afișează automat un câmp unic de Curs Valută, preluat automat de la BNR pentru data documentului, realizând conversia automată în lei a sumelor din notele contabile.",
        "<strong>Preluare Automată Curs BNR:</strong> S-a dezvoltat un endpoint robust de preluare automată a cursului valutar de la BNR, cu rollback automat pe zilele libere/weekend.",
        "<strong>Corecție Eroare Rotunjire PostgreSQL:</strong> S-a corectat funcția trigger <code>intrare_propagate_curs_to_lines</code> prin adăugarea conversiei explicite la <code>::numeric</code> în apelurile funcției <code>ROUND</code>, eliminând erorile la salvarea facturilor cu modificări de curs/date.",
        "<strong>Migrare Rețete în Producție (Firma Impork):</strong> S-au creat tabelele <code>bxreteta</code> și <code>bxretetalinii</code> pe toate bazele de date de pe serverul de producție (192.168.20.205), eliminând eroarea 500 Internal Server Error la accesarea meniului Rețete de către ceilalți tenanți.",
      ],
    },
    {
      date: "21 Iunie 2026",
      badgeColor: "danger",
      title: "🔒 Integritate Date NIR & Corectare Flux Înregistrare",
      category: "Securitate & Integritate",
      description:
        "S-au implementat restricții stricte pentru menținerea consistenței stocurilor și s-a rezolvat eroarea 404 de la confirmarea contului.",
      items: [
        "<strong>Blocare editare linii NIR generat din Intrare:</strong> Dacă un document NIR este generat pe baza unei facturi de intrare, utilizatorul poate schimba în antet doar Gestiunea. Liniile documentului (articol, cantitate, preț, observații) sunt complet blocate la editare, iar butoanele '+ Linie' și 'Șterge' linie sunt ascunse.",
        "<strong>Prevenire documente orfane la ștergere:</strong> S-a blocat ștergerea facturilor de Intrare care au deja un NIR asociat. Pentru a preveni discrepanțele din stocuri (tabelele <code>stocdoc</code> și <code>stocout</code>), utilizatorul este obligat să șteargă mai întâi NIR-ul înainte de a putea șterge factura de intrare.",
        "<strong>Rezolvare eroare 404 Activare Cont:</strong> S-a diagnosticat și corectat redirectul defectuos din timpul înregistrării noilor firme. S-a schimbat variabila <code>FRONTEND_URL</code> în <code>docker-compose.yml</code> de la domeniul vechi <code>edasoft.go.ro</code> la cel valid cu SSL <code>https://erp.edasoft.ro</code>, eliminând toate erorile 404 la confirmarea e-mailului.",
      ],
    },
    {
      date: "16 Iunie 2026",
      badgeColor: "primary",
      title: "🔄 Actualizare & Regenerare Versatilă NIR",
      category: "Gestiune & Stocuri",
      description:
        "S-a optimizat complet fluxul de regenerare a documentului NIR în momentul în care factura de intrare suferă modificări ulterioare generării inițiale.",
      items: [
        "<strong>De-blocare Interfață:</strong> Dacă există deja un NIR asociat facturii și acesta este în starea de Draft, butonul 'Generează NIR' nu mai este ascuns. În locul său, interfața afișează acum două butoane distincte: 'Vezi NIR' (pentru vizualizare rapidă) și 'Actualizează NIR' (pentru actualizare).",
        "<strong>Wizard Precompletat:</strong> Apăsarea pe 'Actualizează NIR' deschide automat ecranul de precompletare NIR (wizard) cu noile articole, cantități și prețuri modificate în factură.",
        "<strong>Sincronizare Cont 327:</strong> La salvarea din wizard, backend-ul execută o actualizare inteligentă (șterge liniile vechi din stocin/stocout și le recreează pe cele noi), regenerând Notele Contabile. Valoarea înregistrată în contul tranzit 327 în NC-ul facturii de intrare va corespunde la leu cu valoarea din NC-ul NIR-ului.",
        "<strong>Corectare Salvare Storno din Wizard:</strong> Liniile storno negative sunt stocate corect ca înregistrări în tabela <code>stocout</code> (scăderi de lot) și nu în <code>stocin</code>. Această separare previne apariția erorilor de bază de date (declanșatoare de stoc negativ) atunci când se modifică sau se salvează NIR-ul din ecranul de editare.",
      ],
    },
    {
      date: "15 Iunie 2026",
      badgeColor: "success",
      title: "💰 Suport TVA la Încasare pentru Achiziții & Sursă Dată NIR",
      category: "Financiar & Contabilitate",
      description:
        "Implementarea regimului special de TVA la Încasare pentru achiziții și îmbunătățirea datelor folosite pentru documentele NIR.",
      items: [
        "<strong>TVA la Încasare (Cont 4428):</strong> La înregistrarea unei facturi de intrare de la un furnizor cu TVA la încasare (flag-ul <code>e_tva_inc</code> bifat), notele contabile folosesc automat contul 4428 (TVA neexigibilă) în loc de 4426 (TVA deductibilă).",
        "<strong>Transfer TVA la Plată:</strong> La plata facturii prin Registrul de Casă sau Deconturi, sistemul generează automat note contabile de transfer proporțional cu plata efectuată: Debit 4426 și Credit 4428.",
        "<strong>Dată NIR din Data Recepției:</strong> Data implicită de pe NIR este extrasă acum din data recepției facturii (<code>bxinput_date</code>), cu fallback la data documentului (<code>bxdoc_date</code>) dacă prima nu este definită.",
        "<strong>Flexibilizare Conturi Grupa Produse:</strong> Contul de tranzit 327 este forțat doar pentru articole stocabile (tip_grupa = 2). Pentru servicii și cheltuieli, se folosește direct contul de cheltuială (clasa 6) setat pe grupă.",
        "<strong>Auto-populare Cont Cheltuială:</strong> La selectarea unui articol non-stocabil pe factura de intrare, contul de debit și codul său se populează automat cu cel de cheltuială din grupa de produse.",
        "<strong>Afișare Linii Storno în NC:</strong> Corectat filtrul din modalul Notei Contabile pentru a afișa și liniile storno cu valori negative (anterior erau ascunse din cauza filtrului pozitiv > 0).",
      ],
    },
    {
      date: "14 Iunie 2026",
      badgeColor: "warning",
      title: "↩️ Funcționalitate Storno Furnizor & Client pe Loturi",
      category: "Stocuri & FIFO",
      description:
        "Implementarea logicii de retur marfă (cantități negative) legată strâns de loturile de proveniență, asigurând integritatea stocurilor și a notelor contabile.",
      items: [
        "<strong>Storno Furnizor (Intrări):</strong> Permite înregistrarea de cantități negative pe factură asociind lotul original de intrare (<code>bxstocin_id</code>). Sistemul generează o scădere de stoc (stocout) pe lot, iar trigger-ul SQL reduce stocul disponibil.",
        "<strong>Storno Client (Ieșiri):</strong> Permite returul de marfă de la client selectând din istoricul de vânzări lotul de unde s-a scăzut marfa prin FIFO. Cantitatea returnată re-crește stocul disponibil pe lotul original.",
        "<strong>Note Contabile Reversate:</strong> Notele contabile de storno înregistrează corect valorile negative în coloanele <code>bxamount</code>, <code>bxsumad</code> și <code>bxsumac</code> pentru reflectarea corectă a rulajelor.",
      ],
    },
    {
      date: "Iunie 2026 (Anterior)",
      badgeColor: "secondary",
      title: "⏳ Limitare Trial 30 de Zile & Ajustări Administrative",
      category: "Securitate & Configurare",
      description:
        "S-au implementat măsuri de siguranță pentru protejarea aplicației și îmbunătățirea uzabilității.",
      items: [
        "<strong>Limitare Trial 30 Zile (ok_go):</strong> Sistemul blochează accesul non-superuserilor dacă au trecut mai mult de 30 de zile de la instalare fără activarea flagului <code>ok_go</code> în tabelul Firma. Un banner galben avertizează utilizatorii cu 5 zile înainte de expirare.",
        "<strong>Buton Ajutor Important:</strong> Butonul dedicat din TopBar oferă asistență rapidă cu layout optimizat pe 80% din înălțimea ecranului (<code>minHeight: '80vh'</code>).",
        "<strong>Versionare Automată:</strong> Definirea versiunii ERP se face centralizat în root (<code>version.txt</code>) și este propagată automat la build în backend și frontend.",
      ],
    },
  ];

  return (
    <Container className="py-4">
      <Card className="shadow border-0 mb-4 bg-white rounded-3">
        <Card.Body className="p-4">
          <div className="d-flex justify-content-between align-items-center mb-3 border-bottom pb-3">
            <div>
              <span className="text-primary fw-semibold text-uppercase tracking-wider text-xs">
                Swan-ERP Documentation
              </span>
              <h2 className="mb-0 mt-1 fw-bold text-dark">
                📖 Istoric Modificări & Ghid Walkthrough
              </h2>
            </div>
            <Link
              to="/"
              className="btn btn-outline-secondary btn-sm rounded-pill px-3"
            >
              Înapoi la Panou
            </Link>
          </div>

          <p className="lead text-muted">
            Acest jurnal centralizează actualizările aduse platformei Swan-ERP
            în ordine cronologică inversă. Aici puteți consulta noile
            funcționalități, fluxuri corectate și integrări.
          </p>

          <Row className="mt-4">
            <Col lg={12}>
              <div className="position-relative ps-3 border-start border-2 border-light">
                {updates.map((up, idx) => (
                  <div className="mb-5 position-relative" key={idx}>
                    {/* Timeline dot */}
                    <div
                      className={`position-absolute rounded-circle bg-${up.badgeColor}`}
                      style={{
                        width: "14px",
                        height: "14px",
                        left: "-21px",
                        top: "6px",
                        border: "3px solid #fff",
                        boxShadow: "0 0 0 2px rgba(0,0,0,0.05)",
                      }}
                    />

                    <div
                      className="p-4 rounded-3 border bg-white shadow-sm"
                      style={{
                        background: "linear-gradient(145deg, #ffffff, #fafbfe)",
                      }}
                    >
                      <div className="d-flex flex-wrap justify-content-between align-items-center mb-3 border-bottom pb-2">
                        <div className="d-flex align-items-center flex-wrap gap-2">
                          <Badge
                            bg={up.badgeColor}
                            className="px-3 py-2 fs-6 fw-bold rounded-pill"
                          >
                            {up.date}
                          </Badge>
                          <h4 className="fw-bold mb-0 text-dark ms-2">
                            {up.title}
                          </h4>
                        </div>
                        <Badge
                          bg="light"
                          className="text-secondary border px-3 py-2 rounded-pill"
                        >
                          {up.category}
                        </Badge>
                      </div>

                      <p className="text-muted mb-3 fs-5">{up.description}</p>

                      {up.tables &&
                        up.tables.map((tbl, tidx) => (
                          <div className="mb-4" key={tidx}>
                            {tbl.title && (
                              <h6 className="fw-bold text-dark mb-2">
                                {tbl.title}
                              </h6>
                            )}
                            <Table
                              bordered
                              striped
                              hover
                              responsive
                              size="sm"
                              className="mb-3 bg-white shadow-sm align-middle"
                            >
                              <thead className="table-light text-secondary">
                                <tr>
                                  {tbl.headers.map((h, hidx) => (
                                    <th key={hidx}>{h}</th>
                                  ))}
                                </tr>
                              </thead>
                              <tbody>
                                {tbl.rows.map((row, ridx) => (
                                  <tr key={ridx}>
                                    {row.map((cell, cidx) => (
                                      <td
                                        key={cidx}
                                        className={
                                          cidx === 0 || cidx === 1
                                            ? "fw-semibold"
                                            : ""
                                        }
                                      >
                                        {cell}
                                      </td>
                                    ))}
                                  </tr>
                                ))}
                              </tbody>
                            </Table>
                          </div>
                        ))}

                      <div className="p-3 bg-white rounded-3 border">
                        <ul className="list-group list-group-flush bg-transparent">
                          {up.items && up.items.map((item, itemIdx) => (
                            <li
                              className="list-group-item bg-transparent px-0 border-0 pt-2 pb-2 d-flex align-items-start"
                              key={itemIdx}
                            >
                              <span
                                className={`text-${up.badgeColor} me-2 fw-bold`}
                              >
                                ✔
                              </span>
                              <span
                                dangerouslySetInnerHTML={{ __html: item }}
                              />
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Col>
          </Row>

          <div className="mt-4 p-4 bg-dark text-white rounded-3">
            <h5 className="fw-bold mb-2">
              💡 Ghid de Simulare și Testare locală eFactura:
            </h5>
            <ol className="mb-0 ps-3">
              <li className="mb-1">
                Navighează la pagina <strong>eFactura (SPV)</strong> din meniul
                de sus.
              </li>
              <li className="mb-1">
                Apasă pe <strong>🔑 Configurare Token</strong> și introdu{" "}
                <code>mock</code> sau <code>test</code> în ambele câmpuri de
                token, apoi apasă pe <strong>Salvează Token</strong>.
              </li>
              <li className="mb-1">
                Salvează o factură de ieșire din modulul{" "}
                <strong>Vânzări / Ieșiri</strong> pentru a o înregistra automat
                în tabela de eFactura.
              </li>
              <li className="mb-1">
                Selectează facturile din tabel și apasă pe{" "}
                <strong>Trimite în SPV</strong> (se vor genera local fișierele
                XML și se va obține un ID încărcare simulat).
              </li>
              <li className="mb-1">
                Apasă pe <strong>Stare SPV</strong> pentru a simula confirmarea
                ANAF OK și citirea ID-ului de recepție.
              </li>
              <li className="mb-0">
                Apasă pe <strong>PDF</strong> pentru a genera local fișierul PDF
                prin tool-ul integrat și a-l vizualiza în browser.
              </li>
            </ol>
          </div>
        </Card.Body>
      </Card>
    </Container>
  );
}
